import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { NotiflowVersion, Collection } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useNotiflowVersions = (
  projectId: string,
  notiflowId: string,
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Collection<NotiflowVersion>>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Collection<NotiflowVersion>>({
    queryKey: ["projects", projectId, "notiflows", notiflowId, "versions"],
    queryFn: async (): Promise<Collection<NotiflowVersion>> => {
      const response = await api.get<Collection<NotiflowVersion>>(`/projects/${projectId}/notiflows/${notiflowId}/versions`);
      return camelize(response.data);
    },
    ...options
  });
};
